import API_CONSTANT from 'constants/apiConstant';
import APP_ROUTES_CONSTANT from 'constants/appRouteConstants';
import GLOBAL_CONSTANT from 'constants/globalConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerFetchCardDetailsApiCall, triggerFetchCardDetailsApiCallSuccess } from 'redux/actions';
import { TRIGGER_FETCH_CARD_DETAILS_API } from 'redux/actionTypes';
import { apiCall } from 'services';
import { ChangeHistory } from 'utils';

function* triggerFetchCardDetailsSagaCall(actions) {
	const { callback, stopLoader } = actions;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.CARD,
		url: API_CONSTANT.URL[`CARD_DETAILS_V2`],
		method: 'GET',
		options: {
			defaultLoader: !stopLoader,
			dontSendSimDetails: true,
		},
		loaderDetails: {
			first_message: 'generating your',
			start_index: 0,
			range: 9,
			second_message: 'card',
		},
	});
	if (api && api?.status === 401) {
		ChangeHistory('push', APP_ROUTES_CONSTANT.somethingWrong);
	} else {
		if (api && api.data.success) {
			const apiData = api.data.data;
			if (apiData.cardStatus === GLOBAL_CONSTANT.CARD_STATUSES.EXPIRED) localStorage.setItem('card-expired', true);
			callback && callback(apiData);
			yield put(triggerFetchCardDetailsApiCallSuccess(apiData));
		}
	}
}

export default function* triggerFetchCardDetailsApiCallSaga() {
	yield takeEvery(TRIGGER_FETCH_CARD_DETAILS_API, triggerFetchCardDetailsSagaCall);
}
